// @flow
// @flow-runtime warn
import { useState, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import path from 'ramda/es/path';
import clone from 'ramda/es/clone';

import api from 'app/actions/api';
import action from 'app/common/lib/action';

import type { SellPointsData } from './sell-points-data-types';


const defaultSellPointsState = {};

export default function useSellPointsData(personId: number, schoolId?: number) {
  const dispatch = useDispatch();

  const [sellPoints, setSellPoints] = useState(defaultSellPointsState);
  const [loading, setLoading] = useState(true);

  const requestSellPoints = useCallback(async () => {
    if (!personId) return;
    const requestPath = 'cafeteria/customer/sale_points';
    const type = 'get';
    const rest = {
      params: {
        customer_id: personId,
        school_id: schoolId,
      },
    };
    try {
      setLoading(true);
      const res = await api(requestPath, type, rest);
      const sellPointsResult: SellPointsData = path(['data', 'sale_points'], res) || defaultSellPointsState;
      setSellPoints(sellPointsResult);
      setLoading(false);
    } catch (error) {
      const errorSave = {
        err: 'Не удалось получить точки продаж',
        path: requestPath,
        rest,
        type,
        error: clone(error),
      };
      dispatch(action('REQUEST_FAILURE', errorSave));
    }
  }, [dispatch, personId, schoolId]);

  useEffect(() => {
    requestSellPoints();
  }, [requestSellPoints]);

  return [sellPoints, loading];
}
